export enum StandardKeyDeliveryStatus {
  BACK_ORDERED = 'BACK_ORDERED',
  PRE_ORDERED = 'PRE_ORDERED',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  CREATED = 'CREATED',
}
